import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Angular 2 decorators and services
 */
import { Component, ViewEncapsulation, ViewChild, ElementRef, } from "@angular/core";
import { AppState } from "./app.service";
import { CheckoutStage } from "@api/endpoints";
import { BasketAssistant } from "@api/services/basket";
import { PortingType } from "./modules/checkout-form/number-porting/number-porting.component";
import { Order, OrderFormPortingItem, OrderBundleTariff, OrderBundleArticle, OrderBundle, OrderBundleOption, } from "@api/schema/order";
import { getOnetimePrice, formatEuro, extractOShopCookie, scrollTo, wait, DDQ, } from "@api/utils";
import { ProductsService } from "@api/services/products";
import { findOneById } from "@api/services/tariff";
import { TrackingError } from "@api/services/tracking";
import config from "@api/config";
import { getPromoSubprices } from "@api/utils";
import { Configurator } from "@api/services/configurator";
import { findOneByComponentSet } from "@api/services/offers";
import { SimpleDialogComponent } from "app/shared/components/simple-dialog";
/**
 * App Component
 * Top Level Component
 */
var AppComponent = /*@__PURE__*/ (function () {
    function AppComponent(appState, elRef) {
        this.appState = appState;
        this.ready = false;
        this.loading = false;
        this.error = false;
        this.basketItemsCount = this.countItems();
        this.deletedBasketItems = [];
        this.updatedBasketItems = [];
        this.isCheckout = false;
        this.eeccLoading = false;
        this.dataChanged = this.dataChanged.bind(this);
        this.onSubmitRequest = this.onSubmitRequest.bind(this);
        this.onEeccRequest = this.onEeccRequest.bind(this);
        this.isCheckout =
            elRef.nativeElement.getAttribute("data-is-checkout") == "true";
    }
    AppComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var basketUpdates, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        BasketAssistant.subscribe("itemsDeleted", function () {
                            _this.countItems();
                        });
                        return [4 /*yield*/, wait(700)];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.checkBasketItemUpdates()];
                    case 2:
                        basketUpdates = _b.sent();
                        _a = basketUpdates;
                        if (_a)
                            return [3 /*break*/, 4];
                        return [4 /*yield*/, BasketAssistant.getTotalAmount()];
                    case 3:
                        _a = (_b.sent()) >
                            BasketAssistant.MAX_ITEMS_ALLOWED;
                        _b.label = 4;
                    case 4:
                        if (_a) {
                            this.itemsUpdatedDialog.open();
                            this.countItems();
                        }
                        BasketAssistant.setThunderBasket();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.countItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var items, counter, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        items = _a.sent();
                        counter = 0;
                        for (item in items) {
                            counter++;
                        }
                        return [2 /*return*/, (this.basketItemsCount = counter)];
                }
            });
        });
    };
    AppComponent.prototype.dataChanged = function (data) {
        this.data = data;
        this.validate();
    };
    AppComponent.prototype.validate = function () {
        var data = this.data;
        var condition = data.contactDetails &&
            data.numberPorting &&
            data.bankAccount &&
            data.terms;
        if (condition && data.terms) {
            this.ready = condition;
        }
        else {
            this.ready = false;
        }
    };
    AppComponent.prototype.checkBasketItemUpdates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var basketItems, deleteAllItems, offersToUpdate, offersToDelete, _a, _b, _i, itemKey, basketItem, componentSet, articleEntity, tariffEntity, _c, _d, component, updatedOffer, e_1, errorMessages, _e, offersToDelete_1, itemToDelete, _f, offersToUpdate_1, itemToUpdate;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        basketItems = _g.sent();
                        return [4 /*yield*/, BasketAssistant.getTotalAmount()];
                    case 2:
                        deleteAllItems = (_g.sent()) >
                            BasketAssistant.MAX_ITEMS_ALLOWED
                            ? true
                            : false;
                        offersToUpdate = [];
                        offersToDelete = [];
                        this.updatedBasketItems = [];
                        this.deletedBasketItems = [];
                        _a = [];
                        for (_b in basketItems)
                            _a.push(_b);
                        _i = 0;
                        _g.label = 3;
                    case 3:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 16];
                        itemKey = _a[_i];
                        basketItem = basketItems[itemKey];
                        componentSet = [];
                        articleEntity = void 0, tariffEntity = void 0;
                        if (!!deleteAllItems)
                            return [3 /*break*/, 14];
                        _g.label = 4;
                    case 4:
                        _g.trys.push([4, 12, , 13]);
                        _c = 0, _d = basketItem.offer.components;
                        _g.label = 5;
                    case 5:
                        if (!(_c < _d.length))
                            return [3 /*break*/, 10];
                        component = _d[_c];
                        if (!(component.type === "tariffMobile"))
                            return [3 /*break*/, 7];
                        return [4 /*yield*/, findOneById(component.subId
                                ? component.subId
                                : component.refId)];
                    case 6:
                        tariffEntity = _g.sent();
                        componentSet.push(tariffEntity);
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, ProductsService.findOneById(component.refId)];
                    case 8:
                        articleEntity = _g.sent();
                        componentSet.push(articleEntity);
                        _g.label = 9;
                    case 9:
                        _c++;
                        return [3 /*break*/, 5];
                    case 10: return [4 /*yield*/, findOneByComponentSet(componentSet)];
                    case 11:
                        updatedOffer = _g.sent();
                        updatedOffer.setUsedOptions(basketItem.offer.getUsedOptions());
                        // const basketItemOfferIdArray =
                        //     basketItem.offer.id.split("+");
                        // const basketItemOfferId = basketItemOfferIdArray[0];
                        if (updatedOffer.getMonthlyPrice() !==
                            basketItem.offer.getMonthlyPrice() ||
                            updatedOffer.getOnetimePrice() !==
                                basketItem.offer.getOnetimePrice()) {
                            offersToUpdate.push({
                                updatedOffer: updatedOffer,
                                oldOffer: basketItem.offer,
                                openDialogue: true,
                                basketItem: basketItem,
                            });
                        }
                        else if (updatedOffer.id != basketItem.offer.id) {
                            offersToUpdate.push({
                                updatedOffer: updatedOffer,
                                oldOffer: basketItem.offer,
                                basketItem: basketItem,
                            });
                        }
                        return [3 /*break*/, 13];
                    case 12:
                        e_1 = _g.sent();
                        //console.log(e);
                        offersToDelete.push({
                            oldOffer: basketItem.offer,
                            openDialogue: true,
                            basketItem: basketItem,
                        });
                        return [3 /*break*/, 13];
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        offersToDelete.push({
                            oldOffer: basketItem.offer,
                            openDialogue: true,
                            basketItem: basketItem,
                        });
                        _g.label = 15;
                    case 15:
                        _i++;
                        return [3 /*break*/, 3];
                    case 16:
                        errorMessages = [];
                        this.updatedBasketItems = this.generateErrorMessages(offersToUpdate);
                        this.deletedBasketItems = this.generateErrorMessages(offersToDelete);
                        _e = 0, offersToDelete_1 = offersToDelete;
                        _g.label = 17;
                    case 17:
                        if (!(_e < offersToDelete_1.length))
                            return [3 /*break*/, 20];
                        itemToDelete = offersToDelete_1[_e];
                        return [4 /*yield*/, BasketAssistant.removeItem(itemToDelete.basketItem)];
                    case 18:
                        _g.sent();
                        _g.label = 19;
                    case 19:
                        _e++;
                        return [3 /*break*/, 17];
                    case 20:
                        _f = 0, offersToUpdate_1 = offersToUpdate;
                        _g.label = 21;
                    case 21:
                        if (!(_f < offersToUpdate_1.length))
                            return [3 /*break*/, 24];
                        itemToUpdate = offersToUpdate_1[_f];
                        return [4 /*yield*/, BasketAssistant.updateItem(itemToUpdate.basketItem, itemToUpdate.updatedOffer)];
                    case 22:
                        _g.sent();
                        _g.label = 23;
                    case 23:
                        _f++;
                        return [3 /*break*/, 21];
                    case 24:
                        this.countItems();
                        return [2 /*return*/, (this.updatedBasketItems.length > 0 ||
                                this.deletedBasketItems.length > 0)];
                }
            });
        });
    };
    AppComponent.prototype.generateErrorMessages = function (items) {
        var basketItems = [];
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.openDialogue) {
                var labels = [];
                for (var _a = 0, _b = item.oldOffer.components; _a < _b.length; _a++) {
                    var component = _b[_a];
                    labels.push(component.internalLabel);
                }
                basketItems.push(labels.join(" mit "));
            }
        }
        return basketItems;
    };
    AppComponent.prototype.handleViewBasketItemChanges = function () {
        window.location.href = config.BASKET_PAGE_URL;
        // scrollTo(".nsf-basket-container");
    };
    AppComponent.prototype.autoClearBasketItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.removeAllItems(true)];
                    case 1:
                        _a.sent();
                        scrollTo(".nsf-basket-container");
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.onSubmitRequest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var basketUpdates, data, order, formData, basket, _a, _b, basketItems, monthlyPriceAfterFirstYear, totalMonthlyPrice, totalDiscounts, counter, mappedOfferKeys, item, basketItem, bundle, article, articleEntity, tariff, tariffEntity, bundleTariff, price, type, socs, promoPrices, promoPriceLabel, _i, promoPrices_1, subprice, price_1, monthlyBasePrice, _c, _d, discount, _e, _f, discount, bundleArticle, _g, _h, option, bundleOption, _j, _k, portingItem, portingItemEntity;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        this.error = false;
                        return [4 /*yield*/, this.checkBasketItemUpdates()];
                    case 1:
                        basketUpdates = _l.sent();
                        if (basketUpdates) {
                            this.loading = false;
                            this.itemsUpdatedDialog.open();
                            this.countItems();
                            return [2 /*return*/];
                        }
                        data = this.data;
                        order = new Order();
                        formData = order.getFormData();
                        basket = order.getBasket();
                        basket.setValid(true);
                        basket.getBasketVoucher();
                        _b = (_a = formData
                            .getMisc()
                            .setEvn("Zielrufnummer verk\u00fcrzt")
                            .setInformation("Off")).setVONumber;
                        return [4 /*yield*/, extractOShopCookie()];
                    case 2:
                        _b.apply(_a, [_l.sent()])
                            .setReverseSearch("Off")
                            .setProvideMsisdn("keine")
                            .setAcceptConditions("Ja");
                        formData
                            .getBank()
                            .setBankName(data.bankAccount.name)
                            .setBankInstitut(data.bankAccount.bank)
                            .setBankIban(data.bankAccount.iban)
                            .setBankBic(data.bankAccount.bic)
                            .setBankSepaApproval(data.bankAccount.accepted === "yes" ? "Ja" : "Off");
                        formData
                            .getContact()
                            .setCity(data.contactDetails.city)
                            .setLegalForm(data.contactDetails.companyRegistration === "registered"
                            ? "Firma"
                            : "Person")
                            .setStreet(data.contactDetails.street)
                            .setStreetNumber(data.contactDetails.streetNumber)
                            .setZipCode(data.contactDetails.zipCode)
                            .setEmail(data.contactDetails.email)
                            .setPassword(data.contactDetails.password)
                            .setFixednetCustomerNumber(data.contactDetails.fixednetCustomerNumber)
                            .setVerification(data.contactDetails.companyRegistration === "registered"
                            ? "Handelsregisterauszug"
                            : "Gewerbeschein")
                            .setPhone(data.contactDetails.phoneNumber)
                            .setAreaCode(data.contactDetails.phonePrefix)
                            .setDivergentBillingAddress("Off");
                        if (data.contactDetails.companyRegistration === "registered") {
                            formData
                                .getContact()
                                .setContactPersonSalutation(data.contactDetails.title)
                                .setContactPersonLastName(data.contactDetails.lastName)
                                .setContactPersonFirstName(data.contactDetails.firstName)
                                .setCompanyName(data.contactDetails.company)
                                .setRegisterNumber(data.contactDetails.registrationNumber)
                                .setRegisterType(data.contactDetails.companyRegistrationEntry)
                                .setRegisterCity(data.contactDetails.companyLegalLocation);
                        }
                        else {
                            formData
                                .getContact()
                                .setBirthDay(data.contactDetails.birthDay)
                                .setBirthMonth(data.contactDetails.birthMonth)
                                .setBirthYear(data.contactDetails.birthYear)
                                .setFirstName(data.contactDetails.firstName)
                                .setLastName(data.contactDetails.lastName)
                                .setNationality(data.contactDetails.citizenship)
                                .setSalutation(data.contactDetails.title);
                            if (data.contactDetails.divergentBillingAddress === "yes") {
                                formData
                                    .getContact()
                                    .setDivergentBillingAddress(data.contactDetails.divergentBillingAddress === "yes"
                                    ? "Ja"
                                    : "Off")
                                    .setDivergentBillingAddressName(data.contactDetails.divergentBillingAddressName)
                                    .setDivergentBillingAddressStreet(data.contactDetails.divergentBillingAddressStreet)
                                    .setDivergentBillingAddressHouseno(data.contactDetails.divergentBillingAddressStreetNumber)
                                    .setDivergentBillingAddressZipCode(data.contactDetails.divergentBillingAddressZipCode)
                                    .setDivergentBillingAddressCity(data.contactDetails.divergentBillingAddressCity);
                            }
                        }
                        formData
                            .getAdditional()
                            .setAgb("true")
                            .setCredit("true")
                            .setRV190011("true")
                            .setRvNr("190013")
                            .setDataAgreement(data.terms.additional_beratung_daten === "yes" ? "Ja" : "Off");
                        //.setOfferAgreement(data.terms.contact === 'yes' ? 'Ja' : 'Off')
                        formData
                            .getPorting()
                            .setIsRequested(data.numberPorting.numberPorting === "yes" ? "Ja" : "Off");
                        if (data.numberPorting.numberPorting === "yes") {
                            formData
                                .getPorting()
                                .setLastProvider(data.numberPorting.serviceProvider)
                                .setCustomerNumber(data.numberPorting.customerNumber)
                                .setIsDivergent(data.numberPorting.contractDetails === "different"
                                ? "Ja"
                                : "Off");
                            if (data.numberPorting.contractDetails === "different") {
                                formData
                                    .getPorting()
                                    .setDivergentName1(data.numberPorting.nameOrCompany)
                                    .setDivergentStreet(data.numberPorting.street)
                                    .setDivergentStreetNumber(data.numberPorting.streetNumber)
                                    .setDivergentZipCode(data.numberPorting.zipCode)
                                    .setDivergentCity(data.numberPorting.city)
                                    .setDivergentBirthDay(data.numberPorting.birthDay
                                    ? data.numberPorting.birthDay
                                    : "1")
                                    .setDivergentBirthMonth(data.numberPorting.birthMonth
                                    ? data.numberPorting.birthMonth
                                    : "1")
                                    .setDivergentBirthYear(data.numberPorting.birthYear
                                    ? data.numberPorting.birthYear
                                    : "1990");
                            }
                            // Number Porting Type
                            if (data.numberPorting.numberPortingType ===
                                PortingType.IS_REQUESTED) {
                                formData.getPorting().setType("schnellstm\u00f6glich");
                            }
                            else if (data.numberPorting.numberPortingType === PortingType.ULTIMO_DATE) {
                                formData
                                    .getPorting()
                                    .setType("Wunschtermin")
                                    .setUltimoDay(data.numberPorting.numberPortingDay)
                                    .setUltimoMonth(data.numberPorting.numberPortingMonth)
                                    .setUltimoYear(data.numberPorting.numberPortingYear);
                            }
                            else if (data.numberPorting.numberPortingType ===
                                PortingType.ULTIMO_CONTRACT) {
                                formData
                                    .getPorting()
                                    .setType("Vertragsende")
                                    .setContractDay(data.numberPorting.numberPortingDay)
                                    .setContractMonth(data.numberPorting.numberPortingMonth)
                                    .setContractYear(data.numberPorting.numberPortingYear);
                            }
                        }
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 3:
                        basketItems = _l.sent();
                        monthlyPriceAfterFirstYear = 0;
                        totalMonthlyPrice = 0;
                        totalDiscounts = 0;
                        counter = 0;
                        mappedOfferKeys = {};
                        for (item in basketItems) {
                            basketItem = basketItems[item];
                            bundle = new OrderBundle();
                            article = void 0;
                            articleEntity = void 0;
                            tariff = void 0;
                            tariffEntity = void 0;
                            counter++;
                            mappedOfferKeys[basketItem.offer.id] = counter;
                            if (tariff) {
                                bundleTariff = new OrderBundleTariff();
                                price = basketItem.offer.getMonthlyPrice() -
                                    basketItem.offer.getMonthlyOptionsSum();
                                price = parseFloat(price.toFixed(2));
                                type = tariffEntity.subscriptionType;
                                if (type === "voicedata") {
                                    type = "voice";
                                }
                                socs = this.getSocs(basketItem);
                                promoPrices = getPromoSubprices(basketItem.offer);
                                promoPriceLabel = "";
                                for (_i = 0, promoPrices_1 = promoPrices; _i < promoPrices_1.length; _i++) {
                                    subprice = promoPrices_1[_i];
                                    price_1 = subprice.price;
                                    promoPriceLabel = promoPriceLabel + " Ab dem " + subprice.runtime + ". Monat " + formatEuro(price_1 * basketItem.amount, true) + "&nbsp;&euro;";
                                }
                                bundleTariff
                                    .setName(tariff.internalLabel)
                                    .setId(tariffEntity.id)
                                    .setPrice(price)
                                    .setRec("mon")
                                    .setValid(true)
                                    .setType(type)
                                    .setLevel(tariffEntity.tariffLevel)
                                    .setPosition(counter)
                                    .setPromoPrice(price)
                                    .setPromoPriceText(promoPriceLabel);
                                if (socs) {
                                    bundleTariff.setAdditionalInfo(socs);
                                }
                                /*
                                if (articleEntity) {
                                    if (articleEntity.usesTopSmartphoneDeal()) {
                                        bundleTariff.setAdditionalInfo('TOPSMARTP');
                                    }
                                }
                                */
                                bundle.setTariff(bundleTariff);
                                monthlyBasePrice = basketItem.offer.getMonthlyOfferPrice() +
                                    basketItem.offer.getMonthlyMandatoryOptionsSum();
                                for (_c = 0, _d = basketItem.offer.getMonthlyDiscounts(); _c < _d.length; _c++) {
                                    discount = _d[_c];
                                    totalDiscounts +=
                                        Math.abs(discount.value) *
                                            discount.duration *
                                            basketItem.amount;
                                }
                                for (_e = 0, _f = basketItem.offer.getMonthlyDiscountPercentages(); _e < _f.length; _e++) {
                                    discount = _f[_e];
                                    totalDiscounts +=
                                        monthlyBasePrice *
                                            (Math.abs(discount.value) / 100) *
                                            discount.duration *
                                            basketItem.amount;
                                }
                                monthlyPriceAfterFirstYear +=
                                    basketItem.offer.getMonthlyPriceAfterFirstYear() *
                                        basketItem.amount;
                                totalMonthlyPrice +=
                                    basketItem.offer.getMonthlyPrice() * basketItem.amount;
                            }
                            if (article) {
                                bundleArticle = new OrderBundleArticle();
                                bundleArticle
                                    .setName(article.internalLabel)
                                    .setId(articleEntity.getSAPId())
                                    .setPrice(getOnetimePrice(article.prices))
                                    .setRec("one")
                                    .setValid(true)
                                    .setImage("//eweb8.vfd2-testnet.de" + articleEntity.getImages().large);
                                bundle.setArticle(bundleArticle);
                            }
                            bundle
                                .setValid(true)
                                .setQty(basketItem.amount)
                                .setId(basketItem.offer.id);
                            if (basketItem.offer.hasUsedOptions()) {
                                for (_g = 0, _h = basketItem.offer.getUsedOptions(); _g < _h.length; _g++) {
                                    option = _h[_g];
                                    bundleOption = new OrderBundleOption();
                                    bundleOption.setId(option.id);
                                    bundle.addOption(bundleOption);
                                }
                            }
                            basket.addBundle(bundle);
                        }
                        if (data.numberPorting.numberPorting === "yes") {
                            for (_j = 0, _k = data.numberPorting.entries; _j < _k.length; _j++) {
                                portingItem = _k[_j];
                                portingItemEntity = new OrderFormPortingItem();
                                portingItemEntity
                                    .setMsisdn(portingItem.phoneNumber)
                                    .setBundleId(portingItem.offer.id) // Offer ids in the examples are DIFFERENT!!!111!
                                    .setTariffName(portingItem.label)
                                    .setPosition(mappedOfferKeys[portingItem.offer.id]);
                                basket.addPortingItem(portingItemEntity);
                            }
                        }
                        this.processOrder(order, data);
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.processOrder = function (order, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, tracking;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CheckoutStage.post({
                            order: JSON.stringify(order),
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.getResponse().orderId)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, Configurator.setAmount(1)];
                    case 2:
                        _a.sent();
                        window.sessionStorage.setItem("vfOrderId", response.getResponse().orderId);
                        window.sessionStorage.setItem("vfOrderNumberPortability", data.numberPorting.numberPorting === "yes" ? "yes" : "no");
                        this.redirectToSuccessPage();
                        return [3 /*break*/, 4];
                    case 3:
                        tracking = new TrackingError();
                        tracking
                            .setType("validation")
                            .setMessage("Checkout submission: Error when submitting order")
                            .track();
                        this.error = true;
                        this.loading = false;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.redirectToSuccessPage = function () {
        window.location.href = config.CHECKOUT_SUCCESS_URL;
    };
    AppComponent.prototype.redirectToErrorPage = function () {
        window.location.href = config.ERROR_URL;
    };
    AppComponent.prototype.onEeccRequest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var basketUpdates, _a, data, order, basket, basketItems, item, basketItem, bundle, _i, _b, option, bundleOption;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.checkBasketItemUpdates()];
                    case 1:
                        basketUpdates = _c.sent();
                        _a = basketUpdates;
                        if (_a)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, BasketAssistant.getTotalAmount()];
                    case 2:
                        _a = (_c.sent()) >
                            BasketAssistant.MAX_ITEMS_ALLOWED;
                        _c.label = 3;
                    case 3:
                        if (_a) {
                            this.itemsUpdatedDialog.open();
                            this.countItems();
                            return [2 /*return*/];
                        }
                        this.eeccLoading = true;
                        data = this.data;
                        order = new Order();
                        basket = order.getBasket();
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 4:
                        basketItems = _c.sent();
                        for (item in basketItems) {
                            basketItem = basketItems[item];
                            bundle = new OrderBundle();
                            bundle
                                .setValid(true)
                                .setQty(basketItem.amount)
                                .setId(basketItem.offer.id);
                            if (basketItem.offer.hasUsedOptions()) {
                                for (_i = 0, _b = basketItem.offer.getUsedOptions(); _i < _b.length; _i++) {
                                    option = _b[_i];
                                    bundleOption = new OrderBundleOption();
                                    bundleOption.setId(option.id);
                                    bundle.addOption(bundleOption);
                                }
                            }
                            basket.addBundle(bundle);
                        }
                        this.processEeccPdf(basket);
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.processEeccPdf = function (basket) {
        return __awaiter(this, void 0, void 0, function () {
            var base64basket, url;
            var _this = this;
            return __generator(this, function (_a) {
                base64basket = btoa(JSON.stringify(basket));
                url = config.EECC_SERVICE + "?" + base64basket;
                fetch(url, {
                    method: "GET",
                    headers: new Headers({}),
                })
                    .then(function (response) { return response.blob(); })
                    .then(function (blob) {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = url;
                    a.download = "Vodafone-Vertragszusammenfassung.pdf";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    _this.eeccLoading = false;
                    DDQ.push([
                        "download file",
                        {
                            name: "geschaeftskunden:handys tablets & internet:checkout:download:download:Vodafone-Vertragszusammenfassung.pdf",
                        },
                    ]);
                })
                    .catch(function (error) {
                    _this.eeccLoading = false;
                    window.location.href = config.BASKET_PAGE_URL;
                    // console.log(error);
                });
                return [2 /*return*/];
            });
        });
    };
    AppComponent.prototype.getSocs = function (basketItem) {
        var socs = null;
        for (var _i = 0, _a = basketItem.offer.getBackendIdsBySystem("SOC"); _i < _a.length; _i++) {
            var soc = _a[_i];
            if (socs !== null) {
                socs += ", " + soc.value;
            }
            else {
                socs = soc.value;
            }
        }
        return socs;
    };
    return AppComponent;
}());
export { AppComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/app.component.ts
// module id = null
// module chunks = 